import React from "react";
import { Row, Col, Card, Skeleton } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";
import { FiveGCompatibilityPie } from "../charts/FiveGCompatibilityPie";
import { FiveGBrandsColumn } from "../charts/FiveGBrandsColumn";
import { FiveGModelsColumn } from "../charts/FiveGModelsColumn";
import { FiveGTrendLine } from "../charts/FiveGTrendLine";
import { FiveGPhoneClicksColumn } from "../charts/FiveGPhoneClicksColumn";

interface FiveGStatsTabProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const FiveGStatsTab: React.FC<FiveGStatsTabProps> = ({
  dateRange,
  shopCode,
}) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/five-g`,
    method: "get",
    config: {
      query: {
        startDate: dateRange[0],
        endDate: dateRange[1],
        ...(shopCode ? { shopCode } : {}),
      },
    },
    queryOptions: { retry: 0 },
  });

  if (isFetching) return <Skeleton active />;

  const data = (response?.data as any) || {
    compatibilityResults: { compatible: 0, incompatible: 0 },
    topBrands: [],
    topModels: [],
    dailyTrend: [],
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={12}>
          <Card title="5G Uyumluluk Oranı" style={{ height: "100%" }}>
            <FiveGCompatibilityPie data={data.compatibilityResults} />
          </Card>
        </Col>
        <Col xs={24} xl={12}>
          <Card
            title="En Çok Sorgulanan Markalar"
            style={{ height: "100%" }}
          >
            <FiveGBrandsColumn data={data.topBrands} />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} xl={12}>
          <Card title="En Çok Sorgulanan Modeller" style={{ height: "100%" }}>
            <FiveGModelsColumn data={data.topModels} />
          </Card>
        </Col>
        <Col xs={24} xl={12}>
          <Card title="5G Günlük Trend" style={{ height: "100%" }}>
            <FiveGTrendLine data={data.dailyTrend} />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <Card title="5G Modaldan En Çok Tıklanan Telefonlar">
            <FiveGPhoneClicksColumn
              dateRange={dateRange}
              shopCode={shopCode}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};
